export enum LocalStorageKeys {
  FieldSystem = 'ls_field_system',
  ExpandRecordPanelSize = 'ls_expand_record_panel_size',
  DashboardKey = 'ls_dashboard_key',
  ViewFromData = 'ls_view_form_data',
  ViewFromMode = 'ls_view_form_mode',
  ViewGridCollapsedGroup = 'ls_view_grid_collapsed_group',
  ViewKanbanCollapsedStack = 'ls_view_kanban_collapsed_stack',
  CompletedGuideMap = 'ls_completed_guide_map',
  ImportAlert = 'ls_import_alert',
  SearchIndexAlert = 'ls_search_index_alert',
  ExpandRecordHiddenFieldsVisible = 'ls_expand_record_hidden_fields_visible',
  EnableGlobalSearch = 'ls_enable_globalSearch',
  TableSearchFieldsCache = 'ls_table_search_fields_cache',
  SearchHideNotMatchRow = 'ls_search_hide_not_match_row',
  PersonalViewMap = 'ls_personal_view_map',
  LockedViewTipVisible = 'ls_locked_view_tip_visible',
  MenuPluginPosition = 'ls_menu_plugin_position',
  PinListExpanded = 'ls_pin_list_expanded',
  InteractionMode = 'ls_interaction_mode',
}
